export const GET_BM_LESSONS = 'GET_BM_LESSONS';
export const UPDATE_LESSON = 'UPDATE_LESSON';
export const DELETE_LESSON = 'DELETE_LESSON';
export const BM_LESSON_LIKES = 'BM_LESSON_LIKES';
export const SET_LESSON = 'SET_LESSON';
export default GET_BM_LESSONS;
